import { useEffect, useRef, useCallback } from "react";
import { wsUrl } from "@/lib/api";

// Subscribes to backend websocket. Calls onMessage for each event.
export function useRealtime(onMessage) {
  const wsRef = useRef(null);
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  const connect = useCallback(() => {
    try {
      const ws = new WebSocket(wsUrl());
      wsRef.current = ws;
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          cbRef.current && cbRef.current(data);
        } catch (err) {}
      };
      ws.onclose = () => {
        // reconnect after delay
        setTimeout(() => {
          if (wsRef.current === ws) connect();
        }, 3000);
      };
      ws.onerror = () => {
        ws.close();
      };
    } catch (e) {}
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) {
        const ws = wsRef.current;
        wsRef.current = null;
        ws.close();
      }
    };
  }, [connect]);
}
